module.exports = __webpack_public_path__ + "static/media/rclicked-mail.9c67131c.svg";